import {
  getChartPiePrimaryPalette,
  readCssVar,
} from '@/utils/chart-theme-colors'
import { getElColorPrimary } from '@/utils/theme-color'

/**
 * 概览区饼图（威胁类型分布、终端分布等）共用配色：主题色为主，再扩展辅助色
 */

/**
 * 运行时读取 Element Plus 主题变量，首项为主题色，随后为同系浅色/深色，再接固定辅助色
 */
export function getOverviewPiePalette (): string[] {
  const primary = readCssVar('--el-color-primary', getElColorPrimary())
  const primarySteps = getChartPiePrimaryPalette(5)
  return [
    primary,
    primarySteps[1],
    primarySteps[2],
    primarySteps[3],
    readCssVar('--el-color-primary-dark-2', getElColorPrimary()),
    '#E77E07', /* dm-keep：图表系列色（橙） */
    '#00A870', /* dm-keep：图表系列色（绿） */
    '#9A60B4', /* dm-keep：图表系列色（紫） */
    '#73C0DE', /* dm-keep：图表系列色（青） */
    '#D54941', /* dm-keep：图表系列色（红） */
  ]
}

/** 威胁类型与调色板顺序对应（保证常见类型稳定用主题色系） */
export function getThreatTypeNamedColors (): Record<string, string> {
  const p = getOverviewPiePalette()
  return {
    勒索病毒: p[0],
    木马程序: p[1],
    挖矿脚本: p[2],
    蝗虫病毒: p[3],
    其他恶意: p[4],
  }
}

export function getOverviewPieSliceColor (
  label: string,
  index: number,
  namedColors: Record<string, string> = {},
): string {
  const key = typeof label === 'string' ? label.trim() : String(label ?? '')
  if (namedColors[key]) {
    return namedColors[key]
  }
  const palette = getOverviewPiePalette()
  return palette[index % palette.length]
}
